import { useEffect, useState } from 'react';
import type { SocialNotification } from '@xiangqi/protocol';
import { api, ensureSession } from '../api.ts';
import { Avatar } from './FriendsScreen.tsx';

interface Props { navigate(path: string): void }
const LABELS: Record<SocialNotification['kind'], string> = {
  friend_request: 'đã gửi lời mời kết bạn.',
  friend_accepted: 'đã chấp nhận lời mời kết bạn.',
  match_invite: 'mời bạn vào một ván đấu.',
  chat_message: 'đã gửi cho bạn một tin nhắn.',
};

export function NotificationsScreen({ navigate }: Props) {
  const [items, setItems] = useState<SocialNotification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    void ensureSession().then(() => api.notifications()).then(async (res) => {
      if (cancelled) return;
      setItems(res.notifications); setLoading(false);
      if (res.unread_count) {
        await api.markNotificationsRead();
        if (!cancelled) setItems((old) => old.map((item) => ({ ...item, read_at: item.read_at ?? new Date().toISOString() })));
      }
    }).catch((e) => { if (!cancelled) { setError(e instanceof Error ? e.message : 'Không tải được thông báo.'); setLoading(false); } });
    return () => { cancelled = true; };
  }, []);
  const go = (item: SocialNotification) => {
    if (item.kind === 'friend_request') navigate('/friends');
    else if (item.kind === 'chat_message' && item.actor) navigate(`/chat?with=${item.actor.user_id}`);
    else if (item.kind === 'match_invite' && typeof item.payload.room_code === 'string') navigate(`/r/${item.payload.room_code}`);
    else if (item.actor) navigate(`/chat?with=${item.actor.user_id}`);
  };
  return <main className="page social-page">
    <header className="social-page-header"><button className="back-button" onClick={() => navigate('/')}>‹</button><div><h1>Thông báo</h1><p>Cập nhật hoạt động của bạn bè</p></div></header>
    {loading ? <p className="social-muted">Đang tải thông báo…</p> : error ? <p className="social-alert">{error}</p> : items.length === 0 ? <div className="social-empty"><span>♧</span><strong>Chưa có thông báo</strong><small>Lời mời kết bạn, tin nhắn và thách đấu sẽ hiển thị tại đây.</small></div> : <section className="notification-list">{items.map((item) => <button className={`notification-item ${item.read_at ? '' : 'unread'}`} key={item.notification_id} onClick={() => go(item)}><Avatar name={item.actor?.display_name ?? 'Cờ'}/><span className="notification-copy"><strong>{item.actor?.display_name ?? 'Hệ thống'}</strong> {LABELS[item.kind]}<small>{new Date(item.created_at).toLocaleString('vi-VN', { dateStyle: 'short', timeStyle: 'short' })}</small></span>{item.kind === 'match_invite' && typeof item.payload.room_code === 'string' && <span className="notification-cta">Vào trận →</span>}</button>)}</section>}
  </main>;
}
